export const levels = [
  { value: 'Primo livello', label: 'Primo livello' },
  { value: 'Secondo livello', label: 'Secondo livello' },
  { value: 'Terzo livello', label: 'Terzo livello' },
  { value: 'Terzo livello Sommelier', label: 'Terzo livello Sommelier' },
  { value: 'Terzo livello Assaggiatore', label: 'Terzo livello Assaggiatore' },
  { value: 'Master monotematico', label: 'Master monotematico' },
];
